import { useEffect, useState } from 'react';

import { DocGenerationSource } from '../constants/docGenerationSource';
import { EditorDocumentAdded, EditorModified } from '../constants/events';
import { OrderAction } from '../constants/orderActions';
import { useAppDispatch } from '../redux-store/hooks';
import { updateOrderActionsAsync } from '../redux-store/orders/ordersSlice';

const useExtractTagDocs = (order: any, currentUserName?: string) => {
  const dispatch = useAppDispatch();
  const [docsTagged, setDocsTagged] = useState<boolean>(false);
  const [docsEdited, setDocsEdited] = useState<boolean>(false);
  const [tagDocsLink, setTagDocsLink] = useState<string>('');

  //
  // Extract the tag docs link for the escrow/settlement agent
  //
  useEffect(() => {
    if (
      (order?.OrderDetails?.SettlementTeam &&
        order?.OrderDetails?.SettlementTeam.length) ||
      (order?.OrderDetails?.EscrowTeam &&
        order?.OrderDetails?.EscrowTeam.length)
    ) {
      let event: any = null;
      let eventDocsTagged: any = null;
      if (order?.OrderType?.DocGen === DocGenerationSource.CX) {
        event =
          order?.OrderDetails?.SettlementTeam[0].SolexSigner?.SignerEvents.filter(
            (event: { Name: string }) => event.Name === 'Open, Links Sent'
          );

        order.OrderDetails?.SettlementTeam.forEach(
          (sa: { SolexSigner: { SignerEvents: any[] } }) => {
            const docsTagged = sa.SolexSigner?.SignerEvents.filter(
              (event: { Name: string }) =>
                event.Name === EditorModified ||
                event.Name == EditorDocumentAdded
            );
            if (docsTagged.length) {
              eventDocsTagged = docsTagged;
            }
          }
        );
      } else if (order?.OrderType?.DocGen === DocGenerationSource.FA) {
        event =
          order?.OrderDetails?.EscrowTeam[0].SolexSigner?.SignerEvents.filter(
            (event: { Name: string }) => event.Name === 'Open, Links Sent'
          );
        order.OrderDetails?.EscrowTeam.forEach(
          (escrow: { SolexSigner: { SignerEvents: any[] } }) => {
            const docsTagged = escrow.SolexSigner?.SignerEvents.filter(
              (event: { Name: string }) =>
                event.Name === EditorModified ||
                event.Name == EditorDocumentAdded
            );
            if (docsTagged.length) {
              eventDocsTagged = docsTagged;
            }
          }
        );
      }
      if (event != null) {
        setTagDocsLink(
          event && event[0] && event[0].DocLink ? event[0].DocLink : ''
        );
      }
      const isTagged = eventDocsTagged && eventDocsTagged[0] ? true : false;
      setDocsTagged(isTagged);
      if (
        isTagged &&
        !(
          OrderAction.PreClosing_SettlementAgent_UploadTagTitledocuments in
          order.Actions
        )
      ) {
        dispatch(
          updateOrderActionsAsync({
            OrderId: order.Id,
            ChecklistId:
              OrderAction.PreClosing_SettlementAgent_UploadTagTitledocuments,
            Complete: true,
            Signer: currentUserName,
          })
        );
      }
      const isEdited: boolean = order?.Events?.find(
        (x: Record<string, string>) =>
          x?.Name == EditorModified || x?.Name == EditorDocumentAdded
      )
        ? true
        : false;
      setDocsEdited(isEdited);
    }
  }, [order]);

  return { docsTagged, docsEdited, tagDocsLink };
};
export default useExtractTagDocs;
